import { login, logout } from "./user";

export const NEW_SOCKET = "socket/new";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const RECEIVE_MESSAGE = "receiveMessage";
export const INIT_SHAPES = "initShapes";
export const LOAD_SHAPES = "loadShape";
export const SEND_MESSAGE = "sendMessage";
export const RECEIVE_SHAPE = "receiveShape";
export const DRAW_SHAPE = "drawShape";
export const RECEIVE_MOUSE = "receiveMouse";
export const SEND_MOUSE = "sendMouse";
export const INITLC = "lc/init";
export const CONNECT_SIGNALR = "connectSignalr";
export const JOIN_ROOM = "joinRoom";
export const LEAVE_ROOM = "leaveRoom";
export const CLEAR_SHAPE_WHEN_LEAVE_ROOM = "clearShapeWhenLeaveRoom";
export const DISCONNECT_SIGNALR = "disconnectSignalr";
export const ONLINE_USERS = "onlineUsers";
export const GET_ONLINE_USERS = "getOnlineUsers";
export const ADD_NOTE = "note/add";
export const UPDATE_NOTE = "note/update";
export const DELETE_NOTE = "note/delete";
export const RECEIVE_NEW_NOTE = "note/receiveNew";
export const RECEIVE_UPDATE_NOTE = "note/receiveUpdate";
export const RECEIVE_REMOVE_NOTE = "note/receiveRemove";
export const CLEAR_ALL = "clearAll";
export const RECEIVE_CLEAR = "receiveClear";
export const UNDO = "undo";
export const REDO = "redo";
export const REMOVE_SHAPE = "shape/remove";
export const LOAD_NOTES = "note/load";
export const INIT_NOTES = "note/init";

export { login };
export { logout };
